import { themeColors } from '../../../themeColors';
/**
 * @file   src\mobile\components\CreateInventory\AddAskingPrice.js
 * @brief  This file is responsible for price section in create inventory
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useState, useEffect, useRef } from "react";
import Form from "react-bootstrap/Form";
import { checkInventoryType } from "../../../helpers/inventory";
import {
  INVENTORY_ALL_TYPE,
  INVENTORY_KEY,
  INVENTORY_KEY_TEMP,
  INVENTORY_LTR,
  INVENTORY_LTR_STR,
  INVENTORY_SELL,
  INVENTORY_SELL_LTR,
  INVENTORY_SELL_STR,
  INVENTORY_STR,
  SELL_ASKING_PRICE,
  LTR_ASKING_PRICE,
  STR_ASKING_PRICE,
} from "../../../constants/common";
import {
  convertToNumber,
  removeNegativeInput,
} from "../../../helpers/validations";
import {
  getLocalStorage,
  replaceComma,
  setBodyBackgroundWhite,
  setLocalStorage,
  thousandSeperatedValue,
} from "../../../helpers/common";
import ProgressBarInventory from "./ProgressBarInventory";
const AddAskingPrice = (props) => {
  const {
    completedPercentage,
    handleFormValues,
    formValues,
    setCompletedPercentage,
    setUIKey,
    isEdit,
  } = props;

  const sellAskngPrice = _.get(formValues, "sellAskngPrice", "");
  const LTRAskngPrce = _.get(formValues, "LTRAskngPrce", "");
  const STRAskngPrce = _.get(formValues, "STRAskngPrce", "");
  const isCompnsteAgent = _.get(formValues, "isCompnsteAgent", "");
  const isCompnsteAgentLTR = _.get(formValues, "isCompnsteAgent_LTR", "");
  const propertyPurpose = _.get(formValues, "proprtyPurpose", "");
  const salesPercnt = _.get(formValues, "salesPercnt", null);
  const salesPercntLTR = _.get(formValues, "salesPercnt_LTR", null);
  const salesPercntSTR = _.get(formValues, "salesPercnt_STR", null);

  const sellAskngPriceInSession = _.get(
    getLocalStorage(INVENTORY_KEY),
    "sellAskngPrice",
    "",
  );
  const LTRAskngPrceInSession = _.get(
    getLocalStorage(INVENTORY_KEY),
    "LTRAskngPrce",
    "",
  );
  const STRAskngPrceInSession = _.get(
    getLocalStorage(INVENTORY_KEY),
    "STRAskngPrce",
    "",
  );
  const isCompnsteAgentInSession = _.get(
    getLocalStorage(INVENTORY_KEY),
    "isCompnsteAgent",
    "",
  );
  const isCompnsteAgentLTRInSession = _.get(
    getLocalStorage(INVENTORY_KEY),
    "isCompnsteAgent_LTR",
    "",
  );

  const salesPercntInSession = _.get(
    getLocalStorage(INVENTORY_KEY),
    "salesPercnt",
    null,
  );
  const salesPercntLTRInSession = _.get(
    getLocalStorage(INVENTORY_KEY),
    "salesPercnt_LTR",
    null,
  );
  const salesPercntSTRInSession = _.get(
    getLocalStorage(INVENTORY_KEY),
    "salesPercnt_STR",
    null,
  );

  const [disableSave, setDisableSave] = useState(true);

  const invType = checkInventoryType(propertyPurpose);
  const isSellOnly = invType === INVENTORY_SELL;
  const isLTROnly = invType === INVENTORY_LTR;
  const isSTROnly = invType === INVENTORY_STR;
  const isSell_And_LTR = invType === INVENTORY_SELL_LTR;
  const isSell_And_STR = invType === INVENTORY_SELL_STR;
  const isSTR_And_LTR = invType === INVENTORY_LTR_STR;
  const isAllType = invType === INVENTORY_ALL_TYPE;
  let askingPrice = sellAskngPrice;
  if (isSTROnly) {
    askingPrice = STRAskngPrce;
  } else if (isLTROnly) {
    askingPrice = LTRAskngPrce;
  }

  const [sellCursorPos, setSellCursorPos] = useState(0);
  const [lTRCursorPos, setLTRCursorPos] = useState(0);
  const [sTRCursorPos, setSTRCursorPos] = useState(0);

  const sellRef = useRef();
  const ltrRef = useRef();
  const strRef = useRef();


  useEffect(() => {
    if (sellRef.current) {
      sellRef.current.setSelectionRange(sellCursorPos, sellCursorPos);
    }
  }, [sellCursorPos]);

  useEffect(() => {
    if (ltrRef.current) {
      ltrRef.current.setSelectionRange(lTRCursorPos, lTRCursorPos);
    }
  }, [lTRCursorPos]);

  useEffect(() => {
    if (strRef.current) {
      strRef.current.setSelectionRange(sTRCursorPos, sTRCursorPos);
    }
  }, [sTRCursorPos]);
  /**
   * To handle asking price field changes
   * @param {*} e
   * @param {*} section
   */
  const handleAskngPriceChange = (e, section) => {
    let value = removeNegativeInput(e.target.value);
    if (value === "0") {
      value = 1;
    }
    switch (section) {
      case SELL_ASKING_PRICE:
        if (isLTROnly) {
          handleFormValues({ [LTR_ASKING_PRICE]: replaceComma(value) });
          if (
            thousandSeperatedValue(LTRAskngPrce)?.length + 1 ==
            thousandSeperatedValue(e.target.value)?.length
          ) {
            setSellCursorPos(e.target.selectionStart);
          } else if (
            thousandSeperatedValue(LTRAskngPrce)?.length + 2 ==
            thousandSeperatedValue(e.target.value)?.length
          ) {
            setSellCursorPos(e.target.selectionStart + 1);
          } else {
            setSellCursorPos(e.target.selectionStart);
          }
        } else if (isSTROnly) {
          handleFormValues({ [STR_ASKING_PRICE]: replaceComma(value) });
          if (
            thousandSeperatedValue(STRAskngPrce)?.length + 1 ==
            thousandSeperatedValue(e.target.value)?.length
          ) {
            setSellCursorPos(e.target.selectionStart);
          } else if (
            thousandSeperatedValue(STRAskngPrce)?.length + 2 ==
            thousandSeperatedValue(e.target.value)?.length
          ) {
            setSellCursorPos(e.target.selectionStart + 1);
          } else {
            setSellCursorPos(e.target.selectionStart);
          }
        } else {
          handleFormValues({ [SELL_ASKING_PRICE]: replaceComma(value) });
          if (
            thousandSeperatedValue(sellAskngPrice)?.length + 1 ==
            thousandSeperatedValue(e.target.value)?.length
          ) {
            setSellCursorPos(e.target.selectionStart);
          } else if (
            thousandSeperatedValue(sellAskngPrice)?.length + 2 ==
            thousandSeperatedValue(e.target.value)?.length
          ) {
            setSellCursorPos(e.target.selectionStart + 1);
          } else {
            setSellCursorPos(e.target.selectionStart);
          }
        }
        break;
      case LTR_ASKING_PRICE:
        handleFormValues({ [LTR_ASKING_PRICE]: replaceComma(value) });
        if (
          thousandSeperatedValue(LTRAskngPrce)?.length + 1 ==
          thousandSeperatedValue(e.target.value)?.length
        ) {
          setLTRCursorPos(e.target.selectionStart);
        } else if (
          thousandSeperatedValue(LTRAskngPrce)?.length + 2 ==
          thousandSeperatedValue(e.target.value)?.length
        ) {
          setLTRCursorPos(e.target.selectionStart + 1);
        } else {
          setLTRCursorPos(e.target.selectionStart);
        }
        break;
      case STR_ASKING_PRICE:
        handleFormValues({ [STR_ASKING_PRICE]: replaceComma(value) });
        if (
          thousandSeperatedValue(STRAskngPrce)?.length + 1 ==
          thousandSeperatedValue(e.target.value)?.length
        ) {
          setSTRCursorPos(e.target.selectionStart);
        } else if (
          thousandSeperatedValue(STRAskngPrce)?.length + 2 ==
          thousandSeperatedValue(e.target.value)?.length
        ) {
          setSTRCursorPos(e.target.selectionStart + 1);
        } else {
          setSTRCursorPos(e.target.selectionStart);
        }
        break;
    }
  };

  /**
   * To handle save button enable/ disable based on field values
   */
  const handleContinueButton = () => {
    let isDisable = true;
    if (isSellOnly) {
      if (sellAskngPrice) {
        isDisable = false;
        setDisableSave(isDisable);
      } else {
        isDisable = true;
        setDisableSave(isDisable);
      }
    }

    if (isLTROnly) {
      if (LTRAskngPrce) {
        isDisable = false;
        setDisableSave(isDisable);
      } else {
        isDisable = true;
        setDisableSave(isDisable);
      }
    }

    if (isSTROnly) {
      if (STRAskngPrce) {
        isDisable = false;
        setDisableSave(isDisable);
      } else {
        isDisable = true;
        setDisableSave(isDisable);
      }
    }

    if (isSell_And_LTR) {
      if (sellAskngPrice && LTRAskngPrce) {
        isDisable = false;
        setDisableSave(isDisable);
      } else {
        isDisable = true;
        setDisableSave(isDisable);
      }
    }

    if (isSell_And_STR) {
      if (sellAskngPrice && STRAskngPrce) {
        isDisable = false;
        setDisableSave(isDisable);
      } else {
        isDisable = true;
        setDisableSave(isDisable);
      }
    }

    if (isSTR_And_LTR) {
      if (LTRAskngPrce && STRAskngPrce) {
        isDisable = false;
        setDisableSave(isDisable);
      } else {
        isDisable = true;
        setDisableSave(isDisable);
      }
    }

    if (isAllType) {
      if (LTRAskngPrce && STRAskngPrce && sellAskngPrice) {
        isDisable = false;
        setDisableSave(isDisable);
      } else {
        isDisable = true;
        setDisableSave(isDisable);
      }
    }
  };

  useEffect(() => {
    if (
      isEdit &&
      convertToNumber(sellAskngPrice) ===
        convertToNumber(sellAskngPriceInSession) &&
      convertToNumber(STRAskngPrce) ===
        convertToNumber(STRAskngPrceInSession) &&
      convertToNumber(LTRAskngPrce) ===
        convertToNumber(LTRAskngPrceInSession) &&
      convertToNumber(salesPercnt) === convertToNumber(salesPercntInSession) &&
      convertToNumber(salesPercntLTR) ===
        convertToNumber(salesPercntLTRInSession) &&
      convertToNumber(salesPercntSTR) ===
        convertToNumber(salesPercntSTRInSession) &&
      isCompnsteAgent === isCompnsteAgentInSession &&
      isCompnsteAgentLTR === isCompnsteAgentLTRInSession
    ) {
      setDisableSave(true);
    } else {
      handleContinueButton();
    }
  }, [
    isCompnsteAgent,
    isCompnsteAgentLTR,
    sellAskngPrice,
    STRAskngPrce,
    LTRAskngPrce,
    salesPercnt,
    salesPercntLTR,
    salesPercntSTR,
  ]);

  /**
   * To handle timtle text based on property use
   * @returns
   */
  function getTitleText() {
    let title;
    if (isSellOnly) {
      title = "How much would you sell your property for?";
    } else if (isLTROnly) {
      title = "How much would you rent your property for each month?";
    } else if (isSTROnly) {
      title = "How much would you rent your property per night on average?";
    } else {
      title = "How much are you willing to price your property at?";
    }
    return title;
  }

  let isShowCompensateAgentSection = isCompnsteAgent;
  if ((isLTROnly && isCompnsteAgentLTR) || isCompnsteAgentLTR === 1) {
    isShowCompensateAgentSection = isCompnsteAgentLTR;
  }

  useEffect(() => {
    setBodyBackgroundWhite();
  }, []);

  return (
    <>
      <div className="gitcha-main-wrapper pb-102 bg-white">
        <div className="content-wrapper content-wrapper-h-102-percent">
          <ProgressBarInventory
            setUIKey={setUIKey}
            completedPercentage={completedPercentage}
            isEdit={isEdit}
          />

          <div className="inner-layout-content-new bg-white pl-16 pr-16 pb-0 ">
            <div className="layout-content-btm-sec position-static pe-0 ps-0">
              <h6 className="">Asking price</h6>
              <h2 className="">{getTitleText()}</h2>
              <p className="titleTextpara mt-2">
                You can adjust your asking price when you send each
                introduction. Our goal is to match your property to
                want-listings.
              </p>
            </div>

            {(isSellOnly ||
              isAllType ||
              isSell_And_LTR ||
              isSell_And_STR ||
              isLTROnly ||
              isSTROnly) && (
              <>
                <div className="stay-timing-wrap mb-4">
                  <div className="lp-btn-group-wrap">
                    <h4>
                      {isAllType || isSell_And_LTR || isSell_And_STR
                        ? "Selling Asking Price"
                        : isLTROnly || isSTROnly
                          ? "Asking Price/Month"
                          : "Asking Price"}
                      *
                    </h4>
                    <div className="row">
                      <div className="col-12">
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Control
                            name="askingPrice"
                            pattern="[0-9]*"
                            inputmode="numeric"
                            value={
                              askingPrice
                                ? thousandSeperatedValue(askingPrice)
                                : ""
                            }
                            placeholder="Asking Price"
                            onChange={(e) => {
                              handleAskngPriceChange(e, SELL_ASKING_PRICE);
                            }}
                            ref={sellRef}
                          />
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {(isAllType || isSell_And_LTR || isSTR_And_LTR) && (
              <>
                <div className="stay-timing-wrap mb-4">
                  <div className="lp-btn-group-wrap">
                    <div className="row">
                      <div className="col-12">
                        <h4>
                          Long-term Renting Asking Price (Monthly){" "}
                          <span>*</span>
                        </h4>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Control
                            className="form-control pad-left-25"
                            name="LTRaskingPrice"
                            pattern="[0-9]*"
                            inputmode="numeric"
                            value={
                              LTRAskngPrce
                                ? thousandSeperatedValue(LTRAskngPrce)
                                : ""
                            }
                            placeholder="Long-term Renting Asking Price"
                            onChange={(e) => {
                              handleAskngPriceChange(e, LTR_ASKING_PRICE);
                            }}
                            ref={ltrRef}
                          />
                        </Form.Group>
                        <div className="error-msg"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {(isAllType || isSell_And_STR || isSTR_And_LTR) && (
              <>
                <div className="stay-timing-wrap mb-4">
                  <div className="lp-btn-group-wrap">
                    <div className="row">
                      <div className="col-12">
                        <Form.Label className="mb-2">
                          Short-term Renting Asking Price (Nightly){" "}
                          <span>*</span>
                        </Form.Label>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Control
                            className="form-control pad-left-25"
                            name="LTRaskingPrice"
                            pattern="[0-9]*"
                            inputmode="numeric"
                            value={
                              STRAskngPrce
                                ? thousandSeperatedValue(STRAskngPrce)
                                : ""
                            }
                            placeholder="Short-term Renting Asking Price"
                            onChange={(e) => {
                              handleAskngPriceChange(e, STR_ASKING_PRICE);
                            }}
                            ref={strRef}
                          />
                        </Form.Group>
                        <div className="error-msg"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="inner-layout-footer-new">
          <div className="inner-btm-fixed-nav ">
            <div className="btn-wrap text-center pb-40 pt-0">
              <button
                type="button"
                className="btn btn-primary w-100 mb-0"
                disabled={disableSave}
                onClick={() => {
                  if (completedPercentage >= 80) {
                    setCompletedPercentage(completedPercentage);
                  } else {
                    setCompletedPercentage(80);
                  }
                  setTimeout(() => {
                    setLocalStorage(
                      INVENTORY_KEY,
                      getLocalStorage(INVENTORY_KEY_TEMP),
                    );
                    setUIKey(null);
                  }, 500);
                }}
              >
                {isEdit ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddAskingPrice;
